import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosClient from "../../axios-client";

export const fetchMyGurdwaraBookings = createAsyncThunk(
  "gurdwara/FetchGurudwaraBookingByCreatedBy",
  async (userId, { rejectWithValue }) => {
    try {
      const response = await axiosClient.put(
        `/Gurudwara/FetchGurudwaraBookingByCreatedBy/${userId}`
      );
      return response.data.Data;
    } catch (error) {
      console.error("Error fetching Gurudwara:", error);
      return rejectWithValue(
        error.response?.data || "Failed to fetch Gurudwara"
      );
    }
  }
);

const initialState = {
  fullName: "",
  email: "",
  serviceType: "",
  mobileNumber1: null,
  mobileNumber2: null,
  mobileNumber3: null,
  eventDate: null,
  eventTime: null,
  eventLocation: "",
  additionalPeople: "",
  currentStep: 1,
  gurdwaras: [],
  termsConditions: 0,
  selectedGurdwara: null,
  serviceTypes: [],
  servicePrices: {},
  selectedServicePrice: "",
  selectedServiceType: null,
  detailGurdwara: "",
  responseId: null,
  paymentStatus: "PENDING",
  paypalID: "",
  terms: "",
  tollFreeNumber: null,
  selectedDate: null,
  selectedTime: null,
  timezone: "America/Los_Angeles, Pacific Time",
  serviceInfo: "",
  serviceAvailableDays: {},
  serviceAvailableTime: {},
  serviceDurations: {},
  serviceCounts: {},
  selectedServiceAvailableDays: [],
  selectedServiceAvailableTime: {},
  selectedServiceAvailableDuration: "",
  selectedServiceCount: "",
  paypalClientID: "",
  paypalSecretKey: "",
  rescheduleCancellationFee: null,
  groomName: "",
  groomPhoneNumber: "",
  brideName: "",
  bridePhoneNumber: "",
  reserveDayBooking: null,
  myGuruLoading: false,
  myGuruBookingList: [],
  myGuruError: "",
  paymentMethod: 3,
  reservePaymentMethod:3,
  paymentDue: {},
  notes: {},
  openNoteBookingId: null,
  openPaymentBookingId: null,
};

const gurdwaraSlice = createSlice({
  name: "gurdwara",
  initialState,
  reducers: {
    resetGurdwara(state) {
      state.fullName = "";
      state.email = "";
      state.serviceType = "";
      state.mobileNumber1 = null;
      state.mobileNumber2 = null;
      state.mobileNumber3 = null;
      state.eventDate = null;
      state.eventTime = null;
      state.eventLocation = "";
      state.additionalPeople = "";
    },
    setFullName(state, action) {
      state.fullName = action.payload;
    },
    setEmail(state, action) {
      state.email = action.payload;
    },
    setServiceType(state, action) {
      state.serviceType = action.payload;
    },
    setMobileNumber1(state, action) {
      state.mobileNumber1 = action.payload;
    },
    setMobileNumber2(state, action) {
      state.mobileNumber2 = action.payload;
    },
    setMobileNumber3(state, action) {
      state.mobileNumber3 = action.payload;
    },
    setEventDate(state, action) {
      state.eventDate = action.payload;
    },
    setEventTime(state, action) {
      state.eventTime = action.payload;
    },
    setEventLocation(state, action) {
      state.eventLocation = action.payload;
    },
    setAdditionalPeople(state, action) {
      state.additionalPeople = action.payload;
    },
    setCurrentStep(state, action) {
      state.currentStep = action.payload;
    },
    setGurdwaras(state, action) {
      state.gurdwaras = action.payload;
    },
    setSelectedGurdwara(state, action) {
      state.selectedGurdwara = action.payload;
    },
    setServiceTypes(state, action) {
      state.serviceTypes = action.payload;
    },
    setSelectedServicePrice(state, action) {
      state.selectedServicePrice = action.payload;
    },
    setServicePrices(state, action) {
      state.servicePrices = action.payload;
    },
    setSelectedServiceType(state, action) {
      state.selectedServiceType = action.payload;
    },
    setDetailGurdwara(state, action) {
      state.detailGurdwara = action.payload;
    },
    setTermsConditions(state, action) {
      state.termsConditions = action.payload;
    },
    setResponseId(state, action) {
      state.responseId = action.payload;
    },
    setPaymentStatus(state, action) {
      state.paymentStatus = action.payload;
    },
    setPaypalID(state, action) {
      state.paypalID = action.payload;
    },
    setTollFreeNumber(state, action) {
      state.tollFreeNumber = action.payload;
    },
    setTerms(state, action) {
      state.terms = action.payload;
    },
    setSelectedDate(state, action) {
      state.selectedDate = action.payload;
    },
    setSelectedTime(state, action) {
      state.selectedTime = action.payload;
    },
    setTimeZone(state, action) {
      state.timezone = action.payload;
    },
    setServiceInfo(state, action) {
      state.serviceInfo = action.payload;
    },
    setServiceAvailableDays(state, action) {
      state.serviceAvailableDays = action.payload;
    },
    setServiceAvailableTime(state, action) {
      state.serviceAvailableTime = action.payload;
    },
    setSelectedServiceAvailableDays(state, action) {
      state.selectedServiceAvailableDays = action.payload;
    },
    setSelectedServiceAvailableTime(state, action) {
      state.selectedServiceAvailableTime = action.payload;
    },
    setServiceDurations(state, action) {
      state.serviceDurations = action.payload;
    },
    setSelectedServiceAvailableDuration(state, action) {
      state.selectedServiceAvailableDuration = action.payload;
    },
    setServiceCounts(state, action) {
      state.serviceCounts = action.payload;
    },
    setSelectedServiceCount(state, action) {
      state.selectedServiceCount = action.payload;
    },
    setPayPalClientID(state, action) {
      state.paypalClientID = action.payload;
    },
    setPayPalSecretKey(state, action) {
      state.paypalSecretKey = action.payload;
    },
    setRescheduleCancellationFee(state, action) {
      state.rescheduleCancellationFee = action.payload;
    },
    setGroomName(state, action) {
      state.groomName = action.payload;
    },
    setGroomPhoneNumber(state, action) {
      state.groomPhoneNumber = action.payload;
    },
    setBrideName(state, action) {
      state.brideName = action.payload;
    },
    setBridePhoneNumber(state, action) {
      state.bridePhoneNumber = action.payload;
    },
    setReserveDayBooking(state, action) {
      state.reserveDayBooking = action.payload;
    },
    setPaymentMethod(state, action) {
      state.paymentMethod = action.payload;
    },
    setReservedPaymentMethod(state, action) {
      state.reservePaymentMethod = action.payload;
    },
    setNotes(state, action) {
      state.notes = action.payload;
    },
    setPaymentDue: (state, action) => {
      state.paymentDue = action.payload;
    },
    setOpenNoteBookingId(state, action) {
      state.openNoteBookingId = action.payload;
    },
    setOpenPaymentBookingId(state, action) {
      state.openPaymentBookingId = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMyGurdwaraBookings.pending, (state) => {
        state.myGuruLoading = true;
      })
      .addCase(fetchMyGurdwaraBookings.fulfilled, (state, action) => {
        state.myGuruLoading = false;
        state.myGuruBookingList = action.payload;
      })
      .addCase(fetchMyGurdwaraBookings.rejected, (state, action) => {
        state.myGuruLoading = false;
        state.myGuruError = action.payload;
      });
  },
});

export const {
  resetGurdwara,
  setFullName,
  setEmail,
  setServiceType,
  setMobileNumber1,
  setMobileNumber2,
  setMobileNumber3,
  setEventDate,
  setEventTime,
  setEventLocation,
  setAdditionalPeople,
  setCurrentStep,
  setGurdwaras,
  setSelectedGurdwara,
  setServiceTypes,
  setSelectedServicePrice,
  setServicePrices,
  setSelectedServiceType,
  setDetailGurdwara,
  setTermsConditions,
  setResponseId,
  setPaymentStatus,
  setPaypalID,
  setTollFreeNumber,
  setReservedPaymentMethod,
  setTerms,
  setSelectedDate,
  setSelectedTime,
  setTimeZone,
  setServiceInfo,
  setServiceAvailableDays,
  setServiceAvailableTime,
  setServiceDurations,
  setServiceCounts,
  setSelectedServiceAvailableDays,
  setSelectedServiceAvailableTime,
  setSelectedServiceAvailableDuration,
  setSelectedServiceCount,
  setPayPalClientID,
  setPayPalSecretKey,
  setRescheduleCancellationFee,
  setGroomName,
  setGroomPhoneNumber,
  setBrideName,
  setBridePhoneNumber,
  setReserveDayBooking,
  setPaymentMethod,
  setNotes,
  setPaymentDue,
  setOpenNoteBookingId,
  setOpenPaymentBookingId,
} = gurdwaraSlice.actions;

export default gurdwaraSlice.reducer;
